import { AnimatedDiv } from 'components/Animation/Animation';
import { Button } from 'components/Button/Button';
import { backofficeLink } from 'helpers/helpers';
import { ArrowButtonWhiteIcon, ArrowScrollToTopIcon, Icon } from 'styles';
import { H1 } from '../../../styles/FontStyles';
import { lightTheme } from '../../../styles/GlobalStyles';
import { Div } from '../../../styles/Styles';
import { Main, Section9Wrapper } from '../Home.styled';

export const Section9 = () => {
  return (
    <Section9Wrapper id='section9'>
      <Main>
        <AnimatedDiv $flex $center $column $gap='50px' $mbSM='50px' $relative>
          <H1 center mb='24' color={lightTheme.white} maxWidth='800px'>
            Ready to secure your position?
          </H1>
          <a
            href={backofficeLink + '/login'}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Button $height='50px' $negative>
              Get Started <ArrowButtonWhiteIcon />
            </Button>
          </a>
          <Div
            $absolute
            $bottom='0'
            $left='0'
            $pointer
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <Icon $size='80px' $sizeSM='40px'>
              <ArrowScrollToTopIcon />
            </Icon>
          </Div>
        </AnimatedDiv>
      </Main>
    </Section9Wrapper>
  );
};
